var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
export var Edit = function (_a) {
    var props = __rest(_a, []);
    return (_jsx("svg", __assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: _jsx("path", { d: "M4 15.1429L3.29289 14.4358C3.10536 14.6233 3 14.8776 3 15.1429H4ZM8.85714 20V21C9.12236 21 9.37671 20.8946 9.56425 20.7071L8.85714 20ZM4 20H3C3 20.5523 3.44772 21 4 21V20ZM17.5571 4.41421L16.85 5.12132L17.5571 4.41421ZM16.85 5.12132L18.8787 7.15004L20.2929 5.73582L18.2642 3.70711L16.85 5.12132ZM4.70711 15.85L14.4214 6.13568L13.0072 4.72146L3.29289 14.4358L4.70711 15.85ZM14.4214 6.13568L15.4358 5.12132L14.0215 3.70711L13.0072 4.72146L14.4214 6.13568ZM18.8787 8.56425L17.8643 9.57861L19.2785 10.9928L20.2929 9.97846L18.8787 8.56425ZM17.8643 9.57861L8.15004 19.2929L9.56425 20.7071L19.2785 10.9928L17.8643 9.57861ZM13.0072 6.13568L17.8643 10.9928L19.2785 9.57861L14.4214 4.72146L13.0072 6.13568ZM8.85714 19H4V21H8.85714V19ZM5 20V15.1429H3V20H5ZM18.8787 7.15004C19.2692 7.54056 19.2692 8.17373 18.8787 8.56425L20.2929 9.97846C21.4645 8.80689 21.4645 6.90739 20.2929 5.73582L18.8787 7.15004ZM18.2642 3.70711C17.0926 2.53553 15.1931 2.53554 14.0215 3.70711L15.4358 5.12132C15.8263 4.7308 16.4594 4.7308 16.85 5.12132L18.2642 3.70711Z", fill: "#068464" }) })));
};
